const fundStatus = [
  { id: 'ACTIVE', value: 'ACTIVE', name: 'Active', label: 'Active' },
  { id: 'PENDING', value: 'PENDING', name: 'Pending', label: 'Pending' }
];

const fundBillingStatus = [
  { id: 'NA', name: 'Feature Not Activated' },
  { id: 'PR', name: 'Pending Review' },
  { id: 'OFNR', name: 'Order Form Not Required' },
  { id: 'POR', name: 'Pending Order Form' },
  { id: 'SOF', name: 'Signed Order Form' }
];

const fundTypes = [
  {
    id: 'Closed Ended – Single Commitment Class',
    value: 'Closed Ended – Single Commitment Class',
    name: 'Closed Ended – Single Commitment Class',
    label: 'Closed Ended – Single Commitment Class'
  },
  {
    id: 'Closed Ended – Multiple Commitment Classes',
    value: 'Closed Ended – Multiple Commitment Classes',
    name: 'Closed Ended – Multiple Commitment Classes',
    label: 'Closed Ended – Multiple Commitment Classes'
  },
  {
    id: 'Closed Ended – Unitized',
    value: 'Closed Ended – Unitized',
    name: 'Closed Ended – Unitized',
    label: 'Closed Ended – Unitized'
  },
  {
    id: 'Open Ended',
    value: 'Open Ended',
    name: 'Open Ended',
    label: 'Open Ended'
  },
  {
    id: 'Managed Parallel Partnerships',
    value: 'Managed Parallel Partnerships',
    name: 'Managed Parallel Partnerships',
    label: 'Managed Parallel Partnerships'
  },
  {
    id: 'Managed Fund Family',
    value: 'Managed Fund Family',
    name: 'Managed Fund Family',
    label: 'Managed Fund Family'
  }
];

export { fundStatus, fundBillingStatus, fundTypes };
